/**
 * 校验金额
 *
 * @param rule 校验规则
 * @param value 需要校验的金额值
 * @param callback 回调函数，用于返回校验结果
 */
export const checkAmount_ = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('金额不能为空'));
  }
  // 正则表达式校验，允许数字和小数点，小数点后最多两位数字
  if (!/^\d+(\.\d{1,2})?$/.test(value)) {
    callback(new Error('请输入正确的金额格式（最多保留两位小数）'));
  } else {
    callback();
  }
}